module.exports = __webpack_public_path__ + "img/mapa-brasil.ffe819b4.png";